import { render, staticRenderFns } from "./roles-form.vue?vue&type=template&id=77949933&"
import script from "./roles-form.vue?vue&type=script&lang=js&"
export * from "./roles-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports